import { FC } from "react";
import { NavLink } from "react-router-dom";

const MemberButton: FC = () => {
	return (
		<div className="flex justify-center">
		<NavLink
		to={"mailto:hello@applia-europe.eu"}
		type="fluid"
		className="text-white lg:self-start bg-primary hover:bg-primary-hover focus:ring-4 focus:ring-blue-300 font-medium rounded-xl text-sm text-center px-10 py-2.5 focus:outline-none"
		>Get in touch to join<br/>hello@applia-europe.eu</NavLink>
		</div>
	);
};

export { MemberButton };